import React from "react";

import Speaker from "assets/img/Group 133.svg";

import "./value-section.styles.scss";

const ValueSection = () => {
  return (
    <div className="value-section">
      <div className="container">
        <div className="value-section_header text-center">
          <h6>Our values</h6>
          <h3 className="mt-3">What drives us to exceed?</h3>
        </div>

        <div className="value-section_cards">
          <div className="row">
            <div className="col-lg-6 col-md-6 mt-5">
              <div className="card">
                <div className="card-body d-flex">
                  <img src={Speaker} alt="speaker"></img>
                  <div className="card-description ml-4">
                    <h4>Social Media Marketing</h4>
                    <p className="mt-3">
                      Social media advertising involves creating and sharing
                      content.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6 col-md-6 mt-5">
              <div className="card">
                <div className="card-body d-flex">
                  <img src={Speaker} alt="speaker"></img>
                  <div className="card-description ml-4">
                    <h4>Website Design & Development</h4>
                    <p className="mt-3">
                      Social media advertising involves creating and sharing
                      content.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6 col-md-6 mt-5">
              <div className="card">
                <div className="card-body d-flex">
                  <img src={Speaker} alt="speaker"></img>
                  <div className="card-description ml-4">
                    <h4>SEO and SEM</h4>
                    <p className="mt-3">
                      Social media advertising involves creating and sharing
                      content.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6 col-md-6 mt-5">
              <div className="card">
                <div className="card-body d-flex">
                  <img src={Speaker} alt="speaker"></img>
                  <div className="card-description ml-4">
                    <h4>Graphic Design</h4>
                    <p className="mt-3">
                      Social media advertising involves creating and sharing
                      content.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6 col-md-6 mt-5">
              <div className="card">
                <div className="card-body d-flex">
                  <img src={Speaker} alt="speaker"></img>
                  <div className="card-description ml-4">
                    <h4>Graphic Design</h4>
                    <p className="mt-3">
                      Social media advertising involves creating and sharing
                      content.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6 col-md-6 mt-5">
              <div className="card">
                <div className="card-body d-flex">
                  <img src={Speaker} alt="speaker"></img>
                  <div className="card-description ml-4">
                    <h4>Graphic Design</h4>
                    <p className="mt-3">
                      Social media advertising involves creating and sharing
                      content.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ValueSection;
